module.exports = __webpack_public_path__ + "img/E-1-3_white_pink_E-1-3_white_pink.7fb1df93.svg";